import ProductsStep from './ProductsStep';
import enhance from './ProductsStepContainer';

const config = {
  name: 'products',
  title: 'products:purchase_order.select_products_step',
  component: enhance(ProductsStep),
};

export default config;
